// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2l0eR","options":"AnswerScale_options__2ps1w","selected":"AnswerScale_selected__15RRr"};